export default __webpack_public_path__ + "static/media/NavLogo.6157aa52.png";